export enum FamilleEgalimEnum {
  VIANDES_VOLAILLES_FRAICHES_SURGELEES,
  CHARCUTERIE,
  PRODUITS_AQUATIQUES_FRAIS_SURGELES_AQUACULTURE,
  FRUITS_LEGUMES_FRAIS_SURGELES,
  BOF,
  BOULANGERIE_PATISSERIE_FRAICHES,
  BOISSONS,
  AUTRES_PRODUITS_FRAIS_SURGELES_EPICERIE
}

